import React from "react";

export const Head = ({ title, sub }) => (
  <div style={{ marginBottom: 20 }}>
    <h1 style={{ fontSize: 30 }}>{title}</h1>
    {sub && <p className="sr-muted" style={{ marginTop: 6 }}>{sub}</p>}
  </div>
);

export const Honest = ({ icon: Icon, title, body, cta }) => (
  <div className="sr-card sr-empty" data-testid="honest-state">
    <Icon size={28} style={{ opacity: .45 }} />
    <h3 style={{ marginTop: 12, fontSize: 18 }}>{title}</h3>
    <p style={{ marginTop: 8, maxWidth: 460, marginInline: "auto" }}>{body}</p>
    {cta}
  </div>
);
